import OrganizationChannelList from './holders/OrganizationChannelList'
import OrganizationContactInfo from './holders/OrganizationContactInfo'
import OrganizationCourseList from './holders/OrganizationCourseList'
import OrganizationEventList from './holders/OrganizationEventList'
import OrganizationInfo from './holders/OrganizationInfo'
import OrganizationNews from './holders/OrganizationNews'
import {OrganizationGroupsGrid} from "./holders/OrganizationGroups";

export const organizationRouteEntities = [
    {
        path: 'overview',
        component: OrganizationInfo,
        breadcrumbName: (t) => t('overview'),
    },
    {
        path: 'news',
        component: OrganizationNews,
        breadcrumbName: (t) => t('news'),
    },
    {
        path: 'channels',
        component: OrganizationChannelList,
        breadcrumbName: (t) => t('channels'),
    },
    {
        path: 'groups',
        component: OrganizationGroupsGrid,
        breadcrumbName: (t) => t('groups / ministries'),
        // QTV (organization.edit) luôn thấy tab để có chỗ tạo hội đoàn/đoàn thể đầu tiên;
        // người xem thường chỉ thấy khi tổ chức đã có ít nhất 1 nhóm
        isInvisible: ({item}) => !item?.edit && !item?.groups?.length,
    },
    {
        path: 'events',
        component: OrganizationEventList,
        breadcrumbName: (t) => t('events'),
        // total_events là count đầy đủ trả từ getById (khác `events` chỉ là preview giới hạn)
        isInvisible: ({item}) => !item?.edit && !item?.total_events,
    },
    {
        path: 'courses',
        component: OrganizationCourseList,
        breadcrumbName: (t) => t('courses'),
        isInvisible: ({item}) => !item?.edit && !item?.workspace_settings?.courses?.statistics?.course_count,
    },
    {
        path: 'contacts',
        component: OrganizationContactInfo,
        breadcrumbName: (t) => t('contact'),
        // isInvisible: (organization) => _.isEmpty(organization?.contacts),
    },
]
